import { useSelector } from 'react-redux'
import { PDFLoader } from 'apps/studio/components/intro/pdfLoader'
import { aiSettingsSelector, plgDemoSelector } from 'apps/studio/store/selectors/studioSettings'
import { addPdf } from 'apps/studio/store/actions/sharedActions'
import {
  UploadIcon,
  RobotIcon,
  ManualFormDesignIcon,
} from '@gocanvas/gcds/icons'

const IntroOption = ({
  Icon,
  label,
  description,
  pdfInputId,
  btnText = 'Upload PDF',
  isAi = false,
}) => {
  const handlePdfUpload = async (blobUrl, fileName, dispatch) => {
    dispatch(addPdf({ pdf_path: blobUrl, fileName, isAi }))
  }
  const Wrapper = pdfInputId ? PDFLoader : 'label'

  // set props on wrapper, e.g. onClick to override direct pdfInput
  // set onFile/onError for custom post upload actions
  return (
    <li className="intro--option">
      <Wrapper
        className="gcds--card  intro--option--item"
        inputId={pdfInputId}
        onFile={handlePdfUpload}
      >
        <Icon className="intro--option--icon" />
        <h4>{label}</h4>
        <p>{description}</p>
        <div type="button" className="gcds--button button--secondary">
          <UploadIcon className="icon--leading" />
          <span className="button--label">{btnText}</span>
        </div>
      </Wrapper>
    </li>
  )
}

const SmallIntroOption = ({ description, clickAction }) => {
  return (
    <li className="intro--option--small">
      <label className="intro--option--item" onClick={clickAction}>
        <p>{description}</p>
        <button type="button" className="gcds--button button--secondary">
          <UploadIcon className="icon--leading" />
          <span className="button--label">Select</span>
        </button>
      </label>
    </li>
  )
}

const options = [
  {
    Component: IntroOption,
    label: 'Auto-Build*',
    Icon: RobotIcon,
    description: `Upload a PDF and we'll do the heavy lifting for you. Customize afterwards.`,
    pdfInputId: `ai-pdf-loader--input`,
    isAi: true,
  },
  {
    Component: IntroOption,
    label: 'Build from Scratch',
    Icon: ManualFormDesignIcon,
    description: `Upload your PDF and then drag and drop fields exactly where you need them.`,
    pdfInputId: `manual-pdf-loader--input`,
  },
  // {
  //   Component: SmallIntroOption,
  //   label: 'Third Option',
  //   Icon: ManualFormDesignIcon,
  //   description: ``,
  //   description: `Description of the 3rd option`,
  //   clickAction: (e) => {
  //     e.preventDefault()
  //     // wrapped action
  //   }
  // },
]

const IntroUpload = ({ subtext = 'Select your PDF and then drag and drop your first field' }) => {
  return (
    <PDFLoader className="studio--intro">
      <div>
        <h2 className="intro-header">Let's get started</h2>
        <p className="intro-subtext">
          {subtext}
        </p>
      </div>
      <div type="button" className="gcds--button button--secondary">
        <UploadIcon className="icon--leading" />
        <span className="button--label">Upload Your Form</span>
      </div>
    </PDFLoader>
  )
}

const AI_LEGALESE =
  "*This feature leverages AWS AI services (e.g., Textract, Bedrock). Please don't upload sensitive or personally identifiable information."

export const Intro = () => {
  const { gocanvas_ai_opt_out, form_autobuild_enabled } =
    useSelector(aiSettingsSelector)
  const plgDemo = useSelector(plgDemoSelector)

  if (plgDemo) {
    const handlePdfUpload = (blobUrl, fileName, dispatch) => {
      dispatch(addPdf({ pdf_path: blobUrl, fileName, isAi: true }))
    }
    return (
      <div className="studio--intro studio--intro--plg">
        <div className="intro-main">
          <div>
            <h2 className="intro-header">Let's get started</h2>
            <p className="intro-subtext">
              Select your PDF and we'll do the heavy lifting for you. You can
              customize afterwards.
            </p>
          </div>
          <PDFLoader onFile={handlePdfUpload}>
            <div type="button" className="gcds--button button--secondary">
              <UploadIcon className="icon--leading" />
              <span className="button--label">Upload Your Form</span>
            </div>
          </PDFLoader>
        </div>
        <p className="intro-footer">{AI_LEGALESE}</p>
      </div>
    )
  }

  return !gocanvas_ai_opt_out && form_autobuild_enabled ? (
    <div className="studio--intro">
      <div className="intro-main">
        <div>
          <h2 className="intro-header">Let's get started</h2>
          <h4 className="intro-subtext">
            How would you like to create your form?
          </h4>
        </div>

        <ol className="studio--intro-options">
          {(plgDemo ? options.filter(o => o.isAi) : options).map((optionConfig, index) => {
            const { Component, ...rest } = optionConfig
            return <Component key={index} {...rest} />
          })}
        </ol>
      </div>
      <h4 className="intro-footer">{AI_LEGALESE}</h4>
    </div>
  ) : (
    <IntroUpload />
  )
}
